import React, { } from 'react';
import { View, TextInput, Image, ActivityIndicator } from 'react-native';

import { CloseIcon } from '../Common-Widget';
import { getImagePath } from '../../services/CommonUtils';

import AppTheme from '../../../AppTheme';
import AppStyles from "../../../AppStyles";
import TextStyle from '../../../TextStyle';

const TextInputSearchView = (props) => {
    const autofocus = props.autofocus ?? false
    const viewWidth = props?.width ?? AppTheme.appWidth - 100
    const textInputWidth = viewWidth - 64

    const isLoading = props?.isLoading
    const textInputValue = props.value
    const placeholder = props?.placeholder ?? 'Search for ...'

    const onChangeText = props.onChangeText

    return <View style={[AppStyles.flexRowSpaceBetween, AppStyles.bg, {
        borderRadius: 8, width: viewWidth,
        paddingVertical: 6, paddingLeft: 18, paddingRight: 10
    }]}><View style={[AppStyles.flexRowStart]}>
            <Image style={{ width: 18, height: 18 }}
                source={{ uri: getImagePath('/images/icons/search_grey.svg') }} />
            <TextInput style={[TextStyle.text14, {
                width: textInputWidth, paddingHorizontal: 12,
                color: AppTheme.color.grey.text
            }]} value={textInputValue} placeholder={placeholder}
                underlineColorAndroid="transparent" autoFocus={autofocus}
                onChangeText={(text) => onChangeText(text)} />
        </View>
        {isLoading ? <ActivityIndicator size={18} color={AppTheme.color.primary} /> :
            textInputValue ? <CloseIcon onPress={() => onChangeText('')} resize={0.8} /> : null}
    </View>
}

export default TextInputSearchView